












































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPopup,
    DxForm,
    DxLookup
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DataSource } from '@/types';
import {
    Table,
    TableConfig,
    defaultTableConfig,
    removeItemsFromView,
    columnTemplates
} from '@/core/components/table';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { InactivityInterval, Vehicle, Crane, Site, Resource } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import Validators from '@/core/helpers/validators';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxRequiredRule,
        DxCustomRule,
        DxLookup
    }
})
export default class UnavailabilityIntervalsListTable extends Validators {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;
    @Prop({ type: Array, required: false }) public vehicles!: Vehicle[];
    @Prop({ type: Array, required: false }) public cranes!: Crane[];
    @Prop({ type: Array, required: false }) public resources!: Resource[];
    @Prop({ type: String, required: false, default: null }) public selectedAlias!: string | null;
    @Prop({ type: String, required: true }) public selectedType!: string | null;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this),
            stateStoring: {
                enabled: false
            }
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
        this.tableInstance.repaint();
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get localize() {
        return localize;
    }

    public get isCarVisible(): boolean {
        return (this.selectedType !== null && this.selectedType === 'Vehicle');
    }

    public get isCraneVisible(): boolean {
        return (this.selectedType !== null && this.selectedType === 'Crane');
    }

    public get isResourceVisible(): boolean {
        return (this.selectedType !== null && this.selectedType === 'Resource');
    }

    public initNewRow(row: any) {
        if (this.selectedAlias) {
            switch (this.selectedType) {
                case 'Vehicle':
                    row.data.vehicleId = this.selectedAlias;
                    break;
                case 'Crane':
                    row.data.craneId = this.selectedAlias;
                    break;
                case 'Resource':
                    row.data.resourceId = this.selectedAlias;
                    break;
                default:
                    break;
            }
        }
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    @Watch('selectedType')
    public reloadTable() {
        if (this.tableInstance.getDataSource()) {
            this.tableInstance.getDataSource().reload();
        }
        this.tableInstance.repaint();
    }

    public deleteUnavailabilityInterval() {
        this._windowsService!.showDialog(
            localize('UnavailabilityIntervalSimpleDeleteMessage'),
            [
                { id: 1, caption: localize('DialogYes') },
                { id: 2, caption: localize('DialogCancel') }
            ]
        ).then(id => {
            if (id === 1) {
                const incativityInterval = this.tableInstance.getSelectedRowsData()[0];
                const data = {
                    InactivityIntervals_Partial: [
                        {
                            id: incativityInterval.id,
                            IsDeleted: true
                        }
                    ]
                };
                const currentContextId = ContextsState.currentContextId;
                const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
                this._fetchService!.post<InactivityInterval>(
                    url,
                    JSON.stringify(data)
                ).then(() => this.getDataGridInstance().refresh());
            }
        });
    }
}
